export const TOKEN = 'token'
export const LANGUAGE = 'language'
export const CITY = 'city'
export const REGION = 'region'
export const DISTRICT = 'district'
